<template>
  <div class="SomeRequirementsforChartering flex-jc-bt text-left">
    <div class="flex-38">
      <SpCard>
        <p class="fs-int">{{ $l('CargoNameConcerned') }}</p>
        <SpSelect name="2.cargoIds" type="warn" multi-select strategy="fixed" :options="cargoNames" />
        <p class="fs-int">{{ $l('Subject') }}</p>
        <SpInput name="2.subject" text-type="textarea" type="warn" />
      </SpCard>
      <p class="card-tip fs-tip">{{ $l('Reminder') }}</p>
    </div>
    <div class="flex-60 right-side sp-color-bg-4">
      <p class="fs-int">{{ $l('paragraphsDesc') }}</p>
      <SpInput name="2.content" text-type="textarea" type="warn3" row="30" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard.vue'
import SpSelect from '@/components/common/SpSelect.vue'
import SpInput from '@/components/common/SpInput.vue'
import SpButton from '@/components/common/SpButton.vue'
import useCargoNameOptions from '@/hooks/business/useCargoNameOptions'
export default {
  name: 'SomeRequirementsforChartering',

  nameSpace: 'cargoOwner.cargo.CharteringOrder.AddNewCharteringOrder.SomeRequirementsforCharteringVue',

  components: {
    SpCard,
    SpInput,
    SpSelect,
    SpButton
  },

  props: {
  },

  setup () {
    const { cargoNames } = useCargoNameOptions()
    return {
      cargoNames
    }
  }
}
</script>

<style scoped lang="less">
.SomeRequirementsforChartering{
  margin-top: @gap;
  .card-tip{
    text-indent: 2em;
  }
  .button-back{
    margin-left: @gap;
    margin-top: @gap*7;
  }
  .right-side{
    padding: @gap;
    margin-top: @gap*2;
  }
}
</style>
